import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import './Buttons.scss';
import CustomTooltip from '../../../../components/card/CustomTooltip';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  ariaLabel: '',
  onClick: () => null,
  disabled: false,
};
const UpdateButton = (props) => {
  const { ariaLabel, onClick, ...rest } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <CustomTooltip title={ariaLabel} aria-label={ariaLabel}>
      <span>
        <IconButton
          {...rest}
          className='admin-action-icon-button'
          aria-label={ariaLabel}
          onClick={onClick}
        >
          <EditIcon />
        </IconButton>
      </span>
    </CustomTooltip>
  );
};

export default UpdateButton;
